/**
 * Compress image to 200x200, quality 80%, return as base64 JPEG
 */
export const compressImage = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const targetSize = 200;
        canvas.width = targetSize;
        canvas.height = targetSize;

        const ctx = canvas.getContext('2d');
        ctx.fillStyle = '#f0f0f0';
        ctx.fillRect(0, 0, targetSize, targetSize);

        // Center crop
        const size = Math.min(img.width, img.height);
        const x = (img.width - size) / 2;
        const y = (img.height - size) / 2;

        ctx.drawImage(img, x, y, size, size, 0, 0, targetSize, targetSize);
        const dataUrl = canvas.toDataURL('image/jpeg', 0.8);
        resolve(dataUrl);
      };
      img.onerror = () => reject(new Error('Failed to load image'));
      img.src = e.target.result;
    };
    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsDataURL(file);
  });
};

/**
 * Get initials avatar (fallback when no photo)
 */
export const getInitialsAvatar = (firstName = '', lastName = '') => {
  const initials = ((firstName[0] || '') + (lastName[0] || '')).toUpperCase();
  const colors = ['#3B82F6', '#8B5CF6', '#EC4899', '#F59E0B', '#10B981', '#06B6D4'];
  const hash = (initials.charCodeAt(0) || 0) + (initials.charCodeAt(1) || 0);
  const bgColor = colors[hash % colors.length];

  return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'%3E%3Ccircle cx='100' cy='100' r='100' fill='${encodeURIComponent(bgColor)}'/%3E%3Ctext x='100' y='110' text-anchor='middle' font-size='80' font-weight='bold' fill='white' font-family='Arial'%3E${initials}%3C/text%3E%3C/svg%3E`;
};
